<template>
    <div class="container my-5">
        <div v-if="kisi.yonetici" class="my-3">
            <p class="float-left" style="background-color: brown; padding: 10px;">
                <b-link style="color: white;" :to="{name: 'kisiBazliHaftalikRapor'}">Kişi Bazlı Haftalık Raporu Görmek İçin Tıklayın.</b-link>
            </p>
            <p class="float-right" style="background-color: teal; padding: 10px;">
                <b-icon style="color: white;" icon="graph-up"></b-icon>
                <b-link style="color: white;" :to="{name: 'haftalikToplamRaporGrafik'}"> Tabloyu Grafiksel Görmek İçin Tıklayın. </b-link>
            </p>
        </div>
        <div v-else>
            <b-alert v-if="kisi.mektupEditor" variant="success" show>Şu zamana kadar {{yaptigiToplamMektup}} mektup yapmışsınız.</b-alert>
            <b-alert v-if="kisi.kartOperator" variant="success" show>Şu zamana kadar {{yaptigiToplamKart}} kart yapmışsınız.</b-alert>
        </div>
        <div style="clear:both;"></div>
        <b-table :busy="isBusy" class="table-responsive-sm" striped hover
                 @row-clicked="haftayaTiklandiginda"
                 :items="liste" :fields="fields">
            <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Rapor Oluşturuluyor...</strong>
                </div>
            </template>
            <template v-slot:head()="scope">
                <div class="text-nowrap">
                    <span v-if="!kisi.yonetici">Yaptığınız</span> {{ scope.label }}
                </div>
            </template>

            <template v-slot:cell(haftaninSirasi)="data">
                <strong>{{liste.length - data.item.haftaninSirasi}}. Hafta</strong>
            </template>
            
            <template v-slot:cell(hafta)="data">
                {{data.item.hafta}}
            </template>
        </b-table>
    </div>
</template>

<script>
    import {ToplamHaftalikRapor} from "@/api/belgeler";
    import {mapGetters} from "vuex";
    import {GoogleTokenIleGirisYapmayiDene} from "@/utils/googlegiris";

    export default {
        name: "ToplamHaftalikRapor",
        data() {
            return {
                isBusy: false,
                yaptigiToplamMektup: 0,
                yaptigiToplamKart: 0,
                liste: [],
                fields: [
                    {
                        key: 'haftaninSirasi',
                        label: 'Kaçıncı Hafta',
                        sortable: true
                    },
                    {
                        key: 'hafta',
                        label: 'Hafta',
                        sortable: true
                    },
                ],
            }
        },
        methods: {
            haftayaTiklandiginda(item) {
                if (!this.kisi.yonetici)
                    return
                
                const baslangic = item.hafta.slice(0, 10)
                
                this.$router.push({name: 'haftalikSaatselRapor', params: {
                        haftaBaslangic: baslangic
                    }})
            }  
        },
        computed: {
            ...mapGetters([
                'kisi', 'girisYapmismi'
            ])
        },
        async created() {
            if (!this.girisYapmismi)
                await new GoogleTokenIleGirisYapmayiDene(this);

            if (!this.girisYapmismi) {
                setTimeout(() => {
                    this.$router.push("/giris-yap?url=" + encodeURI("/haftalik-toplam-rapor"))
                }, 3000);
                return
            }
            
            if (this.kisi.yonetici) {
                this.fields.push(
                    {
                        key: 'bitenMektupSayisi',
                        label: 'Toplam Mektup',
                        sortable: true,
                    },
                    {
                        key: 'bitenKartSayisi',
                        label: 'Toplam Kart',
                        sortable: true,
                    },
                )
            }
            else {
                if (this.kisi.mektupEditor) {
                 this.fields.push({
                     key: 'bitenMektupSayisi',
                     label: 'Toplam Mektup',
                     sortable: true,
                 })   
                }
                if (this.kisi.kartOperator) {
                    this.fields.push(
                        {
                            key: 'bitenKartSayisi',
                            label: 'Toplam Kart',
                            sortable: true,
                        }
                    )
                }
            }
            
            this.isBusy = true
            const { data } = await ToplamHaftalikRapor()
            this.liste = data.liste
            this.yaptigiToplamMektup = data.yaptigiToplamMektup
            this.yaptigiToplamKart = data.yaptigiToplamKart
          
            this.isBusy = false
        }
    }
</script>

<style scoped>

</style>